var _style, _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconNew(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u30EC\\u30A4\\u30E4\\u30FC_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 66 66",
    style: {
      enableBackground: "new 0 0 66 66"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#2B9D1C;}\r\n\t.st1{fill:#FFFFFF;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0,0h66L0,66V0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M4.5,32.3l2.1-2.1l8.6,2.5l3.3,1.2l0.1-0.1c-1.2-1-2.7-2.2-3.9-3.4l-4.2-4.2l2-2L23,34.8l-2.1,2.1l-8.6-2.6 L9,33.2l-0.1,0.1c1.2,1,2.7,2.2,3.9,3.4l4.2,4.2l-2,2L4.5,32.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M14,22.9l6.4-6.4l1.8,1.8l-4.3,4.3l2.4,2.4l3.7-3.7l1.8,1.8L22,26.7l2.8,2.8l4.5-4.5l1.8,1.8l-6.6,6.6L14,22.9 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M21.1,15.8l2.1-2.1l6,4.3c1.3,0.9,2.5,1.9,3.8,2.9l0.1-0.1c-0.9-1.3-1.8-2.7-2.7-4l-3.9-6.3l1.8-1.8l6.3,3.9 c1.3,0.8,2.6,1.8,4,2.7l0.1-0.1c-1-1.3-1.9-2.6-2.9-3.8l-4.3-6l2-2L42,15.8l-2.6,2.6l-6.4-4c-1-0.7-2-1.3-2.9-2l-0.1,0.1 c0.7,0.9,1.3,1.9,2,2.9l4,6.3l-2.6,2.6L21.1,15.8z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNew);
export default __webpack_public_path__ + "static/media/icon_new.f7f5db9d2eabc95f6ba5f9e92be640b5.svg";
export { ForwardRef as ReactComponent };